import { capitalizeText } from '@cat-ecom/common/utils/stringUtils';
import { Equipment } from 'services/equipment/types';

export const equipmentHeader = (equipment: Equipment) => {
  const { assetName = '', name = ''} = equipment || {};
  const asset = assetName ? `${assetName}` : '';
  const [model = '', ...rest] = name.split(' ');
  const restOfTheText = rest ?? [];
  return [`${asset}`,`${model} ${capitalizeText(restOfTheText.join(' '))}`.trim()];
};

export const formatHeader = (equipment: string) => {
  const [model = '', ...rest] = equipment.split(' ');
  const restOfTheText = rest ?? [];
  return `${model} ${capitalizeText(restOfTheText.join(' '))}`.trim();
};
